import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import styles from "./MyTeam.module.scss"
import contest_arrow from "../../../../assets/img/contest_arrow.svg"
import {UserSearchInput} from "./UserSearchInput";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {registrateTeam, setContestId} from "../../NewYearEvent/eventSlice";

const MyTeamPage = () => {

    const [contests, setContest] = useState(null);
    const token = useSelector(state => state.loginSlice.token);
    const contestID = useSelector(state => state.eventSlice.contestId);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [searchQueryLeader, setSearchQueryLeader] = useState('');
    const [selectUserLeader, setSelectUserLeader] = useState('');
    const [searchQueryMemberOne, setSearchQueryMemberOne] = useState('');
    const [selectUserMemberOne, setSelectUserMemberOne] = useState('');
    const [searchQueryMemberTwo, setSearchQueryMemberTwo] = useState('');
    const [selectUserMemberTwo, setSelectUserMemberTwo] = useState('');
    const [searchQueryMemberThree, setSearchQueryMemberThree] = useState('');
    const [selectUserMemberThree, setSelectUserMemberThree] = useState('');
    const [searchQueryMemberFour, setSearchQueryMemberFour] = useState('');
    const [selectUserMemberFour, setSelectUserMemberFour] = useState('');
    const participants = [selectUserMemberOne?.id, selectUserMemberTwo?.id, searchQueryMemberThree?.id, selectUserMemberFour?.id]
    const filteredParticipants = participants.filter(id => id !== null && id !== undefined);

    console.log(filteredParticipants);
    const lead = selectUserLeader.id

    const goToVideo = () => {
        !selectUserLeader ? window.showAlert({title: 'Выберите капитана команды', type: 'error'})
        : dispatch(registrateTeam({token, contestId:contestID, lead, participants: filteredParticipants }))
                .then(() => navigate('/city'))


    }
    useEffect(() => {
        const getContest = async () => {
            try {
                const response = await axios.get('https://vmestemcpb.ru:8085/api/v1/contests/', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setContest(response.data[0]);
                dispatch(setContestId(response.data[0].id))
            } catch (error) {
                console.error('Ошибка при получении данных соревнования', error);
            }
        };
        getContest();
    }, [token]);

    return (
        <div className={styles.teamContainer}>
            <button
                className={styles.goBackBtn}
                onClick={() => navigate("/contest/"+`${contests?.id}`)}
            >
                <img src={contest_arrow} alt={""}/>
                <p>Новогодний конкурс</p>
            </button>
            <h2 className={styles.teamHeading}>Моя команда</h2>
            <UserSearchInput
                searchQuery={searchQueryLeader}
                setSearchQuery={setSearchQueryLeader}
                selectUser={selectUserLeader.name}
                setSelectUser={setSelectUserLeader}
                placeholder="Капитан команды"
            />
            <UserSearchInput
                searchQuery={searchQueryMemberOne}
                setSearchQuery={setSearchQueryMemberOne}
                selectUser={selectUserMemberOne.name}
                setSelectUser={setSelectUserMemberOne}
                placeholder="Участник 1"
            />
            <UserSearchInput
                searchQuery={searchQueryMemberTwo}
                setSearchQuery={setSearchQueryMemberTwo}
                selectUser={selectUserMemberTwo.name}
                setSelectUser={setSelectUserMemberTwo}
                placeholder="Участник 2"
            />
            <UserSearchInput
                searchQuery={searchQueryMemberThree}
                setSearchQuery={setSearchQueryMemberThree}
                selectUser={selectUserMemberThree.name}
                setSelectUser={setSelectUserMemberThree}
                placeholder="Участник 3"
            />
            <UserSearchInput
                searchQuery={searchQueryMemberFour}
                setSearchQuery={setSearchQueryMemberFour}
                selectUser={selectUserMemberFour.name}
                setSelectUser={setSelectUserMemberFour}
                placeholder="Участник 4"
            />
            <div className={styles.btnContainer}>
                <button
                    onClick={goToVideo}
                    className={styles.teamBtn}
                >
                    Далее
                </button>
            </div>
        </div>
    );
};

export {MyTeamPage};
